import React from 'react'
import PropTypes from 'prop-types'

// Styles
import './LessorInfo.scss'

// Components
import Text from 'ui/Text'
import Avatar from 'ui/Avatar'
import Link from 'ui/Link'

// Const
import { PATH_PROFILE } from 'routes/paths'

// Use
import { useSelector } from 'react-redux'

export const LessorInfo = ({ vendorId, companyId, lessorName }) => {
  // State
  const user = useSelector((state) => state.auth.user)

  return (
    <div className="wrap-lessor">
      <div className="lessor-info">
        <div className="lessor-info__avartar">
          <Avatar name={user.email} image={user.avatar} />
        </div>

        <div className="lessor-info__content">
          <Text color="#000000" size={15} style={{ lineHeight: '12px' }}>
            Hi Ka-Globe! You are logged in as
          </Text>
          <Text bold color="#000000" size={20}>
            {user.email}
          </Text>

          <div>
            <Link
              path={PATH_PROFILE}
              params={{
                vendorId,
                companyId,
                lessorName,
              }}
              underline
              style={{
                fontSize: '14px',
                lineHeight: '0px',
                color:
                  lessorName && companyId && vendorId ? '#5badfa' : '#6c757d',
                pointerEvents:
                  lessorName && companyId && vendorId ? 'auto' : 'none',
              }}
            >
              View my profile
            </Link>
          </div>

          <div className="--dess">
            <div>
              Below are details of your contract/s with Globe. You may also view
              and download payment records,
            </div>
            <div>and view the remaining balance</div>
          </div>
        </div>
      </div>

      <div className="lessor-responsive">
        <div className="--dess">
          <div>
            Below are details of your contract/s with Globe. You may also view
            and download payment records,
          </div>
          <div>and view the remaining balance</div>
        </div>
      </div>
    </div>
  )
}

LessorInfo.propTypes = {
  vendorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lessorName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

LessorInfo.defaultProps = {
  vendorId: '',
  companyId: '',
  lessorName: '',
}

export default LessorInfo
